import { createSlice, nanoid } from '@reduxjs/toolkit';

const initialState = {
  queue: [],
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addAlertQueue: (state, action) => {
      state.queue = [];
      state.queue.push({ id: nanoid(), ...action.payload });
    },
    removeAlertQueue: (state) => {
      state.queue = [];
    },
  },
});

export const { addAlertQueue, removeAlertQueue } = snackbarSlice.actions;

export const selectQueue = (state) => state.snackbar.queue;

export const snackbarReducerName = snackbarSlice.name;
export const snackbarReducer = snackbarSlice.reducer;
